<template>
<div class="profile">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header bg-white border-0">
                        <div class="row align-items-center">
                            <div class="col-8">
                                <h3 class="mb-0 text-left">{{$t("forms.profile.editProfile")}}</h3>
                            </div>
                            <div class="col-4 text-right">
                                <router-link class="btn btn-sm btn-danger" to="/profile">{{$t('actions.cancel')}}</router-link>
                            </div>
                        </div>
                        <hr>
                    </div>
                    <div class="card-body">
                        <div v-show="isLoading">
                            <div class="spinner-border text-warning" role="status"><span class="sr-only">Loading...</span></div>
                        </div>
                        <div v-show="!isLoading">
                            <form>
                                <h6 class="heading-small text-muted mb-4">{{$t("forms.profile.userInformation")}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-2 col-12 text-left">
                                            <label class="form-control-label">{{$t("forms.profile.titleLabel")}}</label>
                                            <div class="form-group text-left">
                                                <label class="check mr-1">
                                                    <input type="radio" name="passengerTitle" value="Mr." v-model="user.salutation" />
                                                    <span class="checkmark"></span> {{$t('forms.passengerDetails.mrLabel')}}
                                                </label>
                                                <label class="check ml-1">
                                                    <input type="radio" name="passengerTitle" value="Ms." v-model="user.salutation" />
                                                    <span class="checkmark"></span> {{$t('forms.passengerDetails.msLabel')}}
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <div class="form-group focused">
                                                <label class="form-control-label" for="first-name">{{$t("forms.general.firstName")}}</label>
                                                <input type="text" id="first-name" v-model="user.firstName" class="form-control form-control-alternative" placeholder="I.e. John">
                                            </div>
                                        </div>
                                        <div class="col-lg-5">
                                            <div class="form-group focused">
                                                <label class="form-control-label" for="last-name">{{$t("forms.general.lastName")}}</label>
                                                <input type="text" id="last-name" v-model="user.lastName" class="form-control form-control-alternative" placeholder="I.e. Lewis">
                                            </div>
                                        </div>
                                        <!-- 

</div> -->
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label class="form-control-label" for="email">{{$t("forms.general.email")}}</label>
                                                <input type="email" id="email" v-model="user.email" readonly class="form-control form-control-alternative" placeholder="I.e. jesse@example.com">
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group focused">
                                                <label class="form-control-label" for="phone">{{$t("forms.general.phone")}}</label>
                                                <vue-tel-input v-model="user.phoneNumber" @input="onPhoneInput" :placeholder="$t('forms.passengerDetails.phonePlaceholder')" :enabledFlags="true" inputClasses="form-control form-control-alternative" :preferredCountries="['ch','be']">
                                                </vue-tel-input>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="form-control-label" for="company">{{$t("forms.profile.companyLabel")}}</label>
                                                <input type="text" id="company" v-model="user.company" class="form-control form-control-alternative" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="form-group">
                                                <label class="form-control-label" for="companyVatNumber">{{$t("forms.profile.vatNumberLabel")}}</label>
                                                <input type="text" id="companyVatNumber" v-model="user.companyVatNumber" class="form-control form-control-alternative" placeholder="">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label class="form-control-label" for="culture">{{$t("forms.general.culture")}}</label>
                                                <select name="culture" v-model="user.culture" class="form-control">
                                                    <option value="de">German</option>
                                                    <option value="en">English</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4">
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">{{$t("forms.profile.contactInfo")}}</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group focused">
                                                <label class="form-control-label" for="address">{{$t("forms.general.address")}}</label>
                                                <vue-google-autocomplete id="address" name="address" classname="form-control form-control-alternative" :placeholder="$t('forms.general.address')" :country="null" v-model="user.address" @modelChanged="addressChanged">
                                                </vue-google-autocomplete>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="form-control-label" for="streetNumber">{{$t('forms.profile.streetNameAndNumber')}}</label>
                                                <div class="d-flex">
                                                    <input type="text" id="streetNumber" class="form-control form-control-alternative" style="max-width: 90px; margin-right: 10px;" v-model="user.pickupAddress.streetNumber" :placeholder="$t('forms.general.no')">
                                                    <input type="text" id="streetName" readonly class="form-control form-control-alternative flex-grow-1" v-model="user.pickupAddress.streetName" :placeholder="$t('forms.general.streetName')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row hidden">
                                        <div class="col-lg-4">
                                            <div class="form-group focused">
                                                <label class="form-control-label" for="input-city">{{$t("forms.general.city")}}</label>
                                                <input type="text" id="input-city" readonly class="form-control form-control-alternative" v-model="this.user.pickupAddress.locality" placeholder="City">
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="form-group focused">
                                                <label class="form-control-label" for="input-country">{{$t("forms.general.country")}}</label>
                                                <input type="text" id="input-country" readonly class="form-control form-control-alternative" v-model="this.user.pickupAddress.country" placeholder="Country">
                                            </div>
                                        </div>
                                        <div class="col-lg-4">
                                            <div class="form-group">
                                                <label class="form-control-label" for="input-country">{{$t("forms.general.zipCode")}}</label>
                                                <input type="number" id="input-postal-code" class="form-control form-control-alternative" v-model="this.user.pickupAddress.postalCode" :placeholder="$t('forms.general.zipCode')">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4">
                                <!-- Description -->
                                <h6 class="heading-small text-muted mb-4">{{$t('forms.profile.otherInfo')}}</h6>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group focused">
                                            <label class="form-control-label" for="userPrimaryCar">{{$t("forms.profile.defaultCar")}}</label>
                                            <input type="text" id="userPrimaryCar" class="form-control form-control-alternative" v-model="user.defaultCar" placeholder="I.e. Mercedes S220" value="Mercedes S220">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group focused">
                                            <label class="form-control-label" for="userOtherCar">{{$t("forms.profile.otherCars")}}</label>
                                            <input type="text" id="userOtherCar" class="form-control form-control-alternative" v-model="user.otherCars" placeholder="I.e Mercedes GLS, BMW Series 7">
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group focused">
                                            <label class="form-control-label" for="input-first-name">{{$t("forms.profile.instructionsForPlanner")}}</label>
                                            <textarea class="form-control form-control-alternative" v-model="user.instructionsForDispatcher" placeholder="Ex: My house is right after the corner" rows="5">
											</textarea>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group focused">
                                            <label class="form-control-label" for="input-first-name">{{$t("forms.profile.instructionsForDriver")}}</label>
                                            <textarea class="form-control form-control-alternative" v-model="user.instructionsForDriver" placeholder="Find my hourse right after the bus station" rows="5">
											</textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <div class="row">
                                <div class="col-12 text-center">
                                    <button class="btn btn-primary" @click="this.saveChanges">Save Changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import {
    mapActions
} from "vuex";
import VueGoogleAutocomplete from "../components/vue-google-autocomplete/vue-google-autocomplete.vue";
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput);

export default {
    components: {
        VueGoogleAutocomplete,
    },
    data() {
        return {
            isLoading: true,
            user: {
                email: null,
                phoneNumber: null,
                firstName: null,
                lastName: null,
                salutation: null,
                company: null,
                culture: null,
                address: {},
                pickupAddress: {
                    streetNumber: null,
                    streetName: null,
                    postalCode: null,
                    locality: null,
                    country: null,
                },
                instructionsForDispatcher: null,
                instructionsForDriver: null,
                defaultCar: null,
                otherCars: null
            }
        }
    },
    computed: {
        //...mapState('account', ['status'])
    },
    mounted() {
        this.getUserProfile().then(result => {
            if (!result) return;
            if (result.pickupAddress) {
                result.address = {
                    location: result.pickupAddress,
                    text: result.pickupAddress.formatterAddress
                };
            } else {
                result.pickupAddress = this.user.pickupAddress;
            }
            if (result.otherCars) {
                result.otherCars = result.otherCars.join(", ");
            }
            this.user = result;
            this.isLoading = false;
        });
    },
    methods: {
        addressChanged(locationInfo) {
            if (!locationInfo || !locationInfo.place) return;
            if (!this.user.pickupAddress) this.user.pickupAddress = {};

            this.user.pickupAddress.administrativeAreaLevel1 = locationInfo.place.administrative_area_level_1;
            this.user.pickupAddress.administrativeAreaLevel2 = locationInfo.place.administrative_area_level_2;
            this.user.pickupAddress.country = locationInfo.place.country;
            this.user.pickupAddress.locality = locationInfo.place.locality;
            this.user.pickupAddress.postalCode = locationInfo.place.postal_code;
            this.user.pickupAddress.streetName = locationInfo.place.route;
            this.user.pickupAddress.streetNumber = locationInfo.place.street_number;
            this.user.pickupAddress.address = locationInfo.location.address;
            this.user.pickupAddress.addressName = locationInfo.location.addressName;
            this.user.pickupAddress.latLng = locationInfo.location.latLng;
        },
        onPhoneInput(inputText, numberInfo) {
            if (numberInfo.isValid) {
                this.user.phoneNumber = numberInfo.number.international;
            }
        },
        handleSubmit(e) {
            console.log(e);
            this.submitted = true;
            this.status.loggingIn = true;
            const {
                email,
                password
            } = this;
            if (email && password) {
                this.login({
                        email,
                        password
                    })
                    .then(result => {
                        console.log(this, this.$router, result);
                        this.status.loggingIn = false;
                        this.$router.push("/profile");
                    })
                    .catch(err => {
                        console.log(err);
                        this.errors.length = 0;
                        err.forEach(function (v) {
                            this.errors.push(v);
                        }, this);
                        this.status.loggingIn = false;
                    });
            }
        },
        saveChanges() {
            if (this.user.otherCars && (typeof this.user.otherCars === 'string' || this.user.otherCars instanceof String)) {
                this.user.otherCars = this.user.otherCars.split(',');
            }

            console.log('user before update', this.user);

            this.updateUserProfile(this.user).then(result => {
                if (result != null) {
                    //navigate back
                    this.$router.push("/profile");
                }
                //TODO: error handling
            });
        },
        ...mapActions("account", ["getUserProfile", "updateUserProfile"]),
    }
};
</script>

<style>
.profile .form-group {
    text-align: left !important;
}

.profile .form-control-label {
    font-weight: bold;
    font-size: 14px;
}

.profile h6.heading-small {
    font-weight: bold;
}

.profile .checkbox+.checkbox,
.profile .radio+.radio {
    margin-top: 0 !important;
}

.profile label.checkbox {
    font-weight: normal;
    color: unset;
}

.profile .checkmark {
    margin-top: 2px;
}

.profile .checkbox input:checked+i {
    border-color: #c6c6c6;
}

.profile .checkbox input+i:after {
    color: #7b7b7b;
    top: 2px;
    left: 2px;
}

.profile .radio i,
.profile .checkbox i {
    width: 21px;
    height: 21px;
    border-width: 1px;
    border-color: #ddd;
}

/* General style END */
/*Checkboxes START*/
/* https://bootsnipp.com/snippets/O5oAl  */
/* The radio */
.radio {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none
}

/* Hide the browser's default radio button */
.radio input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.checkround {
    position: absolute;
    top: 6px;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
    border-color: #ced4da;
    border-style: solid;
    border-width: 2px;
    border-radius: 50%;
}

/* When the radio button is checked, add a blue background */
.radio input:checked~.checkround {
    background-color: #fff;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkround:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio input:checked~.checkround:after {
    display: block;
}

/* Style the indicator (dot/circle) */
.radio .checkround:after {
    left: 2px;
    top: 2px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #495057;
}

/* The check */
.check {
    display: inline-block;
    position: relative;
    padding-left: 25px;
    margin-bottom: 12px;
    padding-right: 15px;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.check input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 3px;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #fff;
    border-color: #ced4da;
    border-style: solid;
    border-width: 1px;
}

/* When the checkbox is checked, add a blue background */
.check input:checked~.checkmark {
    background-color: #fff;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.check input:checked~.checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.check .checkmark:after {
    left: 5px;
    top: -1px;
    width: 6px;
    height: 14px;
    border: solid;
    border-color: #495057;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
